import type { AppProps } from "next/app";
import "react-loading-skeleton/dist/skeleton.css";
import { SessionProvider } from "next-auth/react";
import { IntercomProvider } from "react-use-intercom";
import localFont from "next/font/local";
import { ConfigProvider } from "antd";
import { trpc } from "../utils/trpc";
import theme from "../theme/antdTheme";
import WithIntercom from "@components/wrappers/WithIntercom";

import "../styles/main.scss";
import { NotificationProvider } from "hooks/useNotification";

const sohne = localFont({
    src: [
        {
            path: "./fonts/soehne-buch.woff2",
            weight: "400",
            style: "normal",
        },
        {
            path: "./fonts/soehne-buch-kursiv.woff2",
            weight: "400",
            style: "italic",
        },
        {
            path: "./fonts/soehne-kraftig.woff2",
            weight: "500",
            style: "normal",
        },
        {
            path: "./fonts/soehne-kraftig-kursiv.woff2",
            weight: "500",
            style: "italic",
        },
        {
            path: "./fonts/soehne-halbfett.woff2",
            weight: "600",
            style: "normal",
        },
        {
            path: "./fonts/soehne-halbfett-kursiv.woff2",
            weight: "600",
            style: "italic",
        },
    ],
});

const MyApp = ({ Component, pageProps }: AppProps) => {
    return (
        <SessionProvider session={pageProps!.session}>
            <NotificationProvider>
                <IntercomProvider
                    appId={process.env.NEXT_PUBLIC_INTERCOM_APP_ID!}
                >
                    <WithIntercom>
                        <ConfigProvider theme={theme}>
                            <main className={sohne.className}>
                                <Component {...pageProps} />
                            </main>
                        </ConfigProvider>
                    </WithIntercom>
                </IntercomProvider>
            </NotificationProvider>
        </SessionProvider>
    );
};

export default trpc.withTRPC(MyApp);
